<template>
  <editor
        ref="toastuiEditor"
        :initialValue="editorText"
        height = "400px"
        initialEditType = "wysiwyg"
        previewStyle="vertical"
        @change="onUpdateEditor"
    />
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css'
import { Editor } from '@toast-ui/vue-editor'

export default {
  props: {
    editorText: String,
    onUpdate: Function
  },
  components: {
    editor: Editor
  },
  data () {
    return {
      editedAdoptionValue: '',
      defaultOptions: {

      }
    }
  },
  methods: {
    onUpdateEditor () {
      this.editedAdoptionValue = this.$refs.toastuiEditor.invoke('getHTML')
      this.onUpdate(this.editedAdoptionValue)
    }
  }
}
</script>
